<template>
	<v-container fluid>
		<v-card class="mt-2 py-4 px-2" elevation="1" v-show="tabIndex === 0">

		<v-row no-gutters>
			<v-col cols="12" class="pl-3 mb-0 pb-0">
				<v-tabs
					v-show="false"
					class="fornecedor-tabs"
					active-class="activeMyClass"
					background-color="transparent"
					center-active
					v-model="tabIndex"
				>
					<v-tab
						v-for="(item, index) in abas"
						:key="index"
						@click="mudarAba(index)"
					>
						{{ item.title }}
					</v-tab>
				</v-tabs>
			</v-col>
		</v-row>
		<v-row no-gutters v-show="tabIndex === 0">
			<v-col cols="12" class="flex-grow-1 mb-2" align="end">
				<v-btn class="ml-2 my-1" color="primary" @click="exportar()">
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar
				</v-btn>
				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="exportarImportacoes()"
				>
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar<br />
					Importações e Edições
				</v-btn>
				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="exportarLogsAlteracao()"
				>
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar<br />
					Logs Detalhadas
				</v-btn>
				<v-btn
					class="ml-2 my-1"
					color="primary"
					:disabled="mes < mesAtual"
					@click="abrirImportar()"
				>
					<v-icon left>mdi-upload</v-icon> Importar
				</v-btn>
			</v-col>
		</v-row>
			<v-row no-gutters class="mb-2">
				<v-col cols="12" sm="12" md="4" lg="4" xl="4">
					<v-text-field
						v-model="busca"
						append-icon="mdi-magnify"
						label="Pesquisar"
						dense
						outlined
						hide-details
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="12" md="3" lg="3" xl="3"> </v-col>
				<v-col cols="12" sm="12" md="3" lg="3" xl="3">
					<v-form ref="formFiltro">
						<v-text-field
							label="Mês"
							v-model="mes"
							:rules="regra.mes"
							required
							outlined
							dense
							type="month"
						></v-text-field>
					</v-form>
				</v-col>
				<v-col cols="12" sm="12" md="2" lg="2" xl="2" align="end">
					<v-btn class="ml-2 my-1" color="primary" @click="filtrar()">
						<v-icon left>mdi-filter</v-icon> Filtrar
					</v-btn>
				</v-col>
			</v-row>
			<v-data-table
				:headers="headers"
				:items="dados"
				item-key="id_fornecedor"
				:server-items-length="total"
				:items-per-page="5"
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 25, 50, 100],
				}"
				:options.sync="pagination"
				multi-sort
				class="elevation-0"
			>
				<template v-slot:[`item.botao`]="{ item }">
					<v-icon
						
						small
						class="mr-2"
						color="primary"
						@click="enviarGuias(item)"
						title="Guias enviados"
					>
						mdi-checkbook-arrow-right
					</v-icon>
					<v-icon
						v-if="item.mes >= mesAtual"
						small
						class="mr-2"
						color="primary"
						@click="abrirEditar(item)"
						title="Editar"
					>
						mdi-pencil
					</v-icon>
				</template>
			</v-data-table>
		</v-card>

		<!-- Aba Fornecedores Especiais -->
		<v-row no-gutters v-show="false">
			<v-col cols="12" sm="12" md="4" lg="4" xl="4">
				<v-toolbar-title class="ml-2 mt-2"
					>Fornecedores Especiais</v-toolbar-title
				>
			</v-col>
			<v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">
				<v-btn class="ml-2 my-1" color="primary" @click="exportarEspeciais()">
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar
				</v-btn>
				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="abrirImportarEspecial()"
				>
					<v-icon left>mdi-upload</v-icon> Importar
				</v-btn>
			</v-col>
		</v-row>
		<v-card class="mt-2 py-4 px-2" elevation="1" v-show="false">
			<v-row no-gutters class="mb-2">
				<v-col cols="12" sm="12" md="4" lg="4" xl="4">
					<v-text-field
						v-model="buscaEspecial"
						append-icon="mdi-magnify"
						label="Pesquisar"
						dense
						outlined
						hide-details
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="12" md="3" lg="3" xl="3"> </v-col>
				<v-col cols="12" sm="12" md="3" lg="3" xl="3">
					<v-form ref="formFiltroEspecial">
						<v-text-field
							label="Mês"
							v-model="mesEspecial"
							:rules="regra.mes"
							required
							outlined
							dense
							type="month"
						></v-text-field>
					</v-form>
				</v-col>
				<v-col cols="12" sm="12" md="2" lg="2" xl="2" align="end">
					<v-btn class="ml-2 my-1" color="primary" @click="filtrarEspeciais()">
						<v-icon left>mdi-filter</v-icon> Filtrar
					</v-btn>
				</v-col>
			</v-row>
			<v-data-table
				:headers="headersEspeciais"
				:items="dadosEspeciais"
				item-key="id"
				:server-items-length="totalEspeciais"
				:items-per-page="5"
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 25, 50, 100],
				}"
				:options.sync="paginationEspeciais"
				multi-sort
				class="elevation-0"
			>
				<template v-slot:[`item.investimento`]="{ item }">
					{{ formatarMoeda(item.investimento) }}
				</template>
			</v-data-table>
		</v-card>

		<v-dialog v-model="dialogoEnvioGuias" width="1000">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text fix-flex">
					Controle de envio de guias
					<v-spacer></v-spacer>
					<v-btn
							fab
							width="24px"
							height="24px" 
							elevation="0"
							light
							@click="dialogoEnvioGuias = false"
					>
							<v-icon size="18px" color="primary">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="mt-4">
					<controle-envio-guia :fornecedor="fornecedor"/>
				</v-card-text>		
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogo" width="600">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Editar Fornecedor
				</v-card-title>
				<v-card-text class="mt-4">
					<v-form ref="formEditar" v-model="validaForm">
						<v-row no-gutters class="mt-4">
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Código RD"
									v-model="fornecedor.codigo"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="ID Fornecedores"
									v-model="fornecedor.id_fornecedor"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Fornecedores"
									v-model="fornecedor.nome"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="CNPJ"
									v-model="fornecedor.cnpj_matriz"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Razão Social"
									v-model="fornecedor.razao_social"
								></v-text-field>
							</v-col>
							
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Mês"
									v-model="fornecedor.mes_nome"
								></v-text-field>
							</v-col>
							<v-col cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6" class="px-2">
								<v-select
									label="Negociação Comercial"

									outlined
									dense
									v-model="fornecedor.negociacao_comercial"
									:items="['SIM','NÃO']"
									:rules="regra.negociacao_comercial"
									:disabled="fornecedorMesVigente"
									required
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-select
									label="Ignora Acordo"
									:items="lista.ignora_acordo"
									:rules="regra.ignora_acordo"
									item-text="nome"
									item-value="ignora_acordo"
									v-model="fornecedor.ignora_acordo"
									:disabled="fornecedorMesVigente"
									outlined
									dense
								>
								</v-select>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Desconto (%)"
									v-model="fornecedor.desconto"
									:rules="regra.desconto"
									:disabled="fornecedorMesVigente"
									v-mask="'###'"
								></v-text-field>
							</v-col>
							<v-col cols="12" class="px-2" v-if="fornecedor.neogrupo_bloqueado">
								<v-alert type="warning" text border="left" dense class="mb-2">
									Percentuais bloqueados: já existe acordo de negociação comercial para este fornecedor no mês vigente.
								</v-alert>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="4"
								lg="4"
								xl="4"
								class="px-2"
							>
								<vuetify-money
									outlined
									dense
									label="Part. OTC (%)"
									v-model="fornecedor.perc_otc"
									class="input-cinza"
									:error="erroNeogrupoSoma"
									:disabled="fornecedor.neogrupo_bloqueado"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="4"
								lg="4"
								xl="4"
								class="px-2"
							>
								<vuetify-money
									outlined
									dense
									label="Part. Perfumaria (%)"
									v-model="fornecedor.perc_perfumaria"
									class="input-cinza"
									:error="erroNeogrupoSoma"
									:disabled="fornecedor.neogrupo_bloqueado"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="4"
								lg="4"
								xl="4"
								class="px-2"
							>
								<vuetify-money
									outlined
									dense
									label="Part. RX (%)"
									v-model="fornecedor.perc_rx"
									class="input-cinza"
									:error="erroNeogrupoSoma"
									:disabled="fornecedor.neogrupo_bloqueado"
								/>
							</v-col>
							<v-col cols="12" class="px-2" v-if="erroNeogrupoSoma">
								<v-alert type="error" text border="left" dense class="mb-0">
									A soma dos percentuais OTC + Perfumaria + RX deve ser exatamente 100%. Atualmente: {{ somaNeogrupoFornecedor }}%.
								</v-alert>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-select
									label="Macro Fornecedor"
									:items="lista.macrofornecedor"
									item-text="nome"
									item-value="id_macrofornecedor"
									v-model="fornecedor.id_macrofornecedor"
									:disabled="fornecedorMesVigente"
									clearable
									outlined
									dense
								>
								</v-select>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-select
									label="Forma de pagamento"
									:items="lista.forma_pagamento"
									v-model="fornecedor.forma_pagamento"
									:rules="regra.forma_pagamento"
									:disabled="fornecedorMesVigente"
									required
									outlined
									dense
								>
								</v-select>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-select
									label="Número de parcelas"
									:items="lista.parcelas_pagamento"
									v-model="fornecedor.parcelas_pagamento"
									:rules="regra.parcelas_pagamento"
									:disabled="fornecedorMesVigente"
									required
									outlined
									dense
								>
								</v-select>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogo = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
					<v-btn
						color="primary"
						class="pr-4"
						:disabled="erroNeogrupoSoma"
						@click="editar()"
					>
						<v-icon left>mdi-content-save</v-icon> Salvar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoImportar" width="90%">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Importar CSV para
					{{ $moment(mes).format("MMMM [de] YYYY") }}
				</v-card-title>
				<v-card-text>
					<v-alert
						class="mt-4"
						text
						type="info"
						border="left"
						style="font-size: 12px;"
					>
						<ul>
							<li>
								A base utilizada para importação deve ser
								parecida com base exportada. As colunas
								<strong>codigo_rd</strong> (Código RD) e
								<strong>desconto</strong> (Desconto) são
								obrigatórias (<strong
									>e os nomes devem ser identicos aos da base
									exportada</strong
								>), as demais colunas podem ser excluidas.
							</li>
							<li>
								Na coluna <strong>desconto</strong> (Desconto) o
								valor deve conter um número inteiro entre
								<strong>0</strong> e <strong>100</strong>.
								Qualquer valor não inteiro fora deste intervalo
								sera conciderado como <strong>0</strong>.
							</li>
							<li>
								A coluna <strong>mes</strong> não é considerada
								na importação do <strong>desconto</strong>.
							</li>
							<li>
								O <strong>mês</strong> considerado na importação
								do <strong>desconto</strong> é o mês selecionano
								no
								<strong>filtro da lista de fornecedores</strong
								>.
							</li>
						<li>
								As colunas <strong>perc_otc</strong>, <strong>perc_perfumaria</strong> e <strong>perc_rx</strong> são opcionais.
								Quando preenchidas, a soma dos três valores deve ser exatamente <strong>100</strong>.
							</li>
							<li v-if="importarMesVigente">
								Para o <strong>mês vigente</strong>, as colunas
								<strong>desconto</strong>, <strong>negociacao_comercial</strong>,
								<strong>ignora_acordo</strong>, <strong>forma_pagamento</strong>,
								<strong>parcelas_pagamento</strong> e <strong>macrofornecedor</strong>
								serão <strong>ignoradas</strong> na importação.
							</li>
							<li v-if="importarMesVigente">
								Percentuais (<strong>perc_otc</strong>, <strong>perc_perfumaria</strong>, <strong>perc_rx</strong>)
								de fornecedores que já possuem acordo de negociação comercial no mês vigente serão <strong>ignorados</strong>.
							</li>
						</ul>
					</v-alert>
					<v-row no-gutters>
						<v-col cols="8" class="px-2">
							<v-form ref="form" v-model="isCsv">
								<v-file-input
									label="Arquivo CSV"
									outlined
									dense
									v-model="arquivoCSV"
									:rules="regra.csv"
									accept=".csv"
								></v-file-input>
							</v-form>
						</v-col>
						<v-col cols="4" class="px-2">
							<v-btn
								color="primary"
								:disabled="!isCsv"
								@click="importar()"
							>
								<v-icon left>mdi-upload</v-icon>
								Importar Arquivo
							</v-btn>
						</v-col>
					</v-row>
					<v-expand-transition>
						<div v-show="erro">
							<v-row no-gutters class="mb-0">
								<v-col cols="6">
									<download-csv
										:data="erros"
										:labels="errosLabels"
										name="erros.csv"
										delimiter=";"
									>
										<v-btn color="primary">
											<v-icon left
												>mdi-microsoft-excel</v-icon
											>
											Exportar Erros
										</v-btn>
									</download-csv>
								</v-col>
							</v-row>
							<v-data-table
								:headers="headerErros"
								:items="erros"
								:items-per-page="5"
								:options.sync="paginationErros"
								class="elevation-0 data-table-2"
							></v-data-table>
						</div>
					</v-expand-transition>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogoImportar = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoImportarEspecial" width="90%">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Importar CSV Fornecedores Especiais
				</v-card-title>
				<v-card-text>
					<v-alert
						class="mt-4"
						text
						type="info"
						border="left"
						style="font-size: 12px;"
					>
						<ul>
							<li>
								A base utilizada para importação deve ser
								parecida com base exportada.
							</li>
							<li>
								A coluna de <strong>Mês</strong> deve seguir o seguinte formato <strong>YYYY-MM ({{ $moment(mes).format("YYYY-MM") }})</strong>.
							</li>
							<li>
								As seguintes colunas são obrigatórias:
							</li>
							<ul>

								<li><strong>Mês</strong></li>
								<li><strong>Código RD Fornecedor</strong></li>
								<li><strong>Categoria</strong></li>
								<li><strong>Bandeira</strong></li>
								<li><strong>Investimento</strong></li>
							</ul>
						</ul>
					</v-alert>
					<v-row no-gutters>
						<v-col cols="8" class="px-2">
							<v-form ref="formEspecial" v-model="isCsvEspecial">
								<v-file-input
									label="Arquivo CSV"
									outlined
									dense
									v-model="arquivoCSVEspecial"
									:rules="regra.csv"
									accept=".csv"
								></v-file-input>
							</v-form>
						</v-col>
						<v-col cols="4" class="px-2">
							<v-btn
								color="primary"
								:disabled="!isCsvEspecial"
								@click="importarEspecial()"
							>
								<v-icon left>mdi-upload</v-icon>
								Importar Arquivo
							</v-btn>
						</v-col>
					</v-row>
					<v-expand-transition>
						<div v-show="erro">
							<v-row no-gutters class="mb-0">
								<v-col cols="6">
									<download-csv
										:data="erros"
										:labels="errosLabels"
										name="erros.csv"
										delimiter=";"
									>
										<v-btn color="primary">
											<v-icon left
												>mdi-microsoft-excel</v-icon
											>
											Exportar Erros
										</v-btn>
									</download-csv>
								</v-col>
							</v-row>
							<v-data-table
								:headers="headerErros"
								:items="erros"
								:items-per-page="5"
								:options.sync="paginationErros"
								class="elevation-0 data-table-2"
							></v-data-table>
						</div>
					</v-expand-transition>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn
						color="yellow"
						class="ml-2"
						dark
						@click="exportarModeloEspecial()"
					>
						<v-icon left>mdi-microsoft-excel</v-icon>
						Baixar modelo de importação
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogoImportarEspecial = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-overlay :value="carregando" :z-index="300">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar
			v-model="alerta"
			:color="alertaColor"
			:timeout="alertaTimeout"
			top
			style="z-index: 400"
		>
			<v-alert :type="alertaColor">
				{{ alertaTexto }}
			</v-alert>
			<v-btn dark text class="float-right" @click="alerta = false">
				Fechar
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import ControleEnvioGuia from './ControleEnvioGuia.vue';
export default {
	data() {
		return {
			tabIndex: 0,
			abas: [
				{ title: "Fornecedores" },
				{ title: "Fornecedores Especiais" }
			],
			headers: [
				{ text: "Código RD", value: "codigo", align: "center" },
				{
					text: "ID Fornecedor",
					value: "id_fornecedor",
					align: "center",
				},
				{ text: "Fornecedor", value: "nome", align: "center" },
				{ text: "CNPJ Matriz", value: "cnpj_matriz", align: "center" },
				{
					text: "Razão Social",
					value: "razao_social",
					align: "center",
				},
				{ text: "Mês", value: "mes_nome", align: "center" },
				{ text: "Desconto (%)", value: "desconto", align: "center" },
				{
					text: "Macro Fornecedor",
					value: "macrofornecedor",
					align: "center",
				},
				{
					text: "Ignora Acordo",
					value: "ignora_acordostr",
					align: "center",
				},
				{ text: "Negociação Comercial", value: "negociacao_comercial", align: "center" },
				{ text: "", value: "botao", align: "center", sortable: false },
			],
			headersEspeciais: [
				{ text: "Código Fornecedor", value: "codigo_fornecedor", align: "center" },
				{
					text: "ID Fornecedor",
					value: "id_fornecedor",
					align: "center",
				},
				{ text: "Fornecedor", value: "fornecedor", align: "center" },
				{ text: "Categoria", value: "categoria", align: "center" },
				{ text: "Bandeira", value: "bandeira", align: "center" },
				{ text: "Mês", value: "mes_nome", align: "center" },
				{ text: "Investimento (R$)", value: "investimento", align: "center" },
				{ text: "Obs. Contrato", value: "obs_contrato", align: "center" },
				{ text: "Obs. Departamento", value: "obs_departamento", align: "center" },
			],
			dados: [],
			dadosEspeciais: [],
			mes: null,
			mesEspecial: null,
			fornecedor: {
				id_fornecedor: null,
				codigo: null,
				nome: null,
				desconto: null,
				id_macrofornecedor: null,
				ignora_acordo: null,
				negociacao_comercial: 'NÃO',
				forma_pagamento: null,
				parcelas_pagamento: null,
				perc_otc: null,
				perc_perfumaria: null,
				perc_rx: null
			},
			pagination: {},
			paginationEspeciais: {},
			paginationErros: {},
			total: null,
			totalEspeciais: 0,
			carregando: false,
			busca: null,
			buscaEspecial: null,
			dialogo: false,
			dialogoImportar: false,
			dialogoImportarEspecial: false,
			dialogoEnvioGuias: false,
		validaForm: false,
		alerta: false,
		alertaTexto: "",
		alertaColor: "error",
		alertaTimeout: 3000,
		arquivoCSV: null,
		arquivoCSVEspecial: null,
		isCsvEspecial: false,
			lista: {
				macrofornecedor: [],
				ignora_acordo: [],
				forma_pagamento: ['Débito bancário', 'Abatimento', 'Bonificação'],
				parcelas_pagamento: [
                        {
                            text: 'Única',
                            value: 1,
                        },
                        {
                            text: '2x',
                            value: 2,
                        },
                        {
                            text: '3x',
                            value: 3,
                        },
                    ]
			},
			regra: {
				desconto: [
					(v) =>
						(!!v && v >= 0 && v <= 100) ||
						"O desconto deve ser um numero inteiro ente 0 e 100.",
				],
				csv: [
					(v) => !!v || "Selecione um arquivo.",
					(v) =>
						(!!v && [".csv", ".CSV"].includes(v.name.substr(-4))) ||
						"O arquivo deve ser do tipo CSV.",
				],
				mes: [(v) => !!v || "O campo mês é obrigatório."],
				ignora_acordo: [
					(v) => v !== null || "O campo ignora acordo é obrigatório.",
				],
				negociacao_comercial: [(v) => !!v || "O campo negociação comercial é obrigatório."],
				forma_pagamento: [(v) => !!v || "O campo forma de pagamento é obrigatório."],
				parcelas_pagamento: [(v) => !!v || "O campo número de parcelas é obrigatório."],
			},
			isCsv: false,
			headerErros: [
				{ text: "Descrição do Erro", value: "msg", align: "left" },
			],
			erros: [],
			errosLabels: { msg: "Descrição do Erro" },
			erro: false,
		};
	},
	watch: {
		pagination: {
			handler() {
				this.filtrar();
			},
			deep: true,
		},
		busca(v) {
			setTimeout(() => {
				if (v == this.busca) {
					this.filtrar();
				}
			}, 1500);
		},
		buscaEspecial(v) {
			setTimeout(() => {
				if (v == this.buscaEspecial) {
					this.filtrarEspeciais();
				}
			}, 1500);
		},
		paginationEspeciais: {
			handler() {
				this.filtrarEspeciais();
			},
			deep: true,
		},
	},
	async created() {
		this.mes = this.mesProximo;
		this.mesEspecial = this.$moment().format("YYYY-MM");

		var response = await this.$http().post("/macrofornecedor/lista", {
			data: {},
		});
		const listaIgnoraAcordo = [
			{ ignora_acordo: false, nome: "NÃO" },
			{ ignora_acordo: true, nome: "SIM" },
		];

		this.lista.ignora_acordo = listaIgnoraAcordo;
		this.lista.macrofornecedor = response.data;
	},
	components: {ControleEnvioGuia},
	computed: {
		mesAtual() {
			return this.$moment().format("YYYY-MM");
		},
		fornecedorMesVigente() {
			if (!this.fornecedor.mes) return false
			return this.$moment(this.fornecedor.mes).format("YYYY-MM") === this.mesAtual
		},
		importarMesVigente() {
			return this.mes === this.mesAtual
		},
		mesProximo() {
			return this.$moment()
				.add(1, "months")
				.format("YYYY-MM");
		},
		erroNeogrupoSoma() {
			const otc = parseFloat(this.fornecedor.perc_otc);
			const perf = parseFloat(this.fornecedor.perc_perfumaria);
			const rx = parseFloat(this.fornecedor.perc_rx);
			const algumPreenchido = !isNaN(otc) || !isNaN(perf) || !isNaN(rx);
			if (!algumPreenchido) return false;
			const soma = Math.round(((isNaN(otc) ? 0 : otc) + (isNaN(perf) ? 0 : perf) + (isNaN(rx) ? 0 : rx)) * 100) / 100;
			return soma !== 100;
		},
		somaNeogrupoFornecedor() {
			const otc = parseFloat(this.fornecedor.perc_otc) || 0;
			const perf = parseFloat(this.fornecedor.perc_perfumaria) || 0;
			const rx = parseFloat(this.fornecedor.perc_rx) || 0;
			return Math.round((otc + perf + rx) * 100) / 100;
		},
	},
	methods: {
		formatarMoeda(valor) {
			if (valor === null || valor === undefined) return 'R$ 0,00';
			return new Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL'
			}).format(valor);
		},
		mudarAba(index) {
			this.tabIndex = index;
		},
		async filtrar() {
			if (!this.$refs.formFiltro.validate()) return;

			this.carregando = true;

			var data = { mes: this.mes + "-01" };

			data.pagination = this.pagination;
			data.busca = this.busca;

			var response = await this.$http().post("/fornecedor/lista", {
				data: data,
			});

			this.dados = response.data;
			this.total = response.data.length ? response.data[0].total : 0;

			response.data.forEach((item) => {
				item.ignora_acordostr = item.ignora_acordo ? "SIM" : "NÃO";
			});

			if (this.total == 0 && this.pagination.page > 1) {
				this.pagination.page = 1;
				this.filtrar();
			}

			this.carregando = false;
		},
		async filtrarEspeciais() {
			if (!this.$refs.formFiltroEspecial.validate()) return;

			this.carregando = true;

			var data = { mes: this.mesEspecial + "-01" };

			data.pagination = this.paginationEspeciais;
			data.busca = this.buscaEspecial;

			var response = await this.$http().post("/fornecedorEspecial/lista", {
				data: data,
			});

			this.dadosEspeciais = response.data;
			this.totalEspeciais = response.data.length ? response.data[0].total : 0;

			if (this.totalEspeciais == 0 && this.paginationEspeciais.page > 1) {
				this.paginationEspeciais.page = 1;
				this.filtrarEspeciais();
			}

			this.carregando = false;
		},
		async exportar() {
			if (!this.$refs.formFiltro.validate()) return;

			this.carregando = true;

			var data = { mes: this.mes + "-01" };

			var response = await this.$http().post("/fornecedor/exportar", {
				data: data,
			});

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		async exportarEspeciais() {
			if (!this.$refs.formFiltroEspecial.validate()) return;

			this.carregando = true;

			var data = { mes: this.mesEspecial + "-01" };

			var response = await this.$http().post("/fornecedorEspecial/exportar", {
				data: data,
			});

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		async exportarModeloEspecial() {
			this.carregando = true;

			var response = await this.$http().post("/fornecedorEspecial/exportarModelo", {
				data: {},
			});

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		async exportarImportacoes() {
			this.carregando = true;

			var response = await this.$http().post(
				"/fornecedor/exportarHistImportacoes",
				{ data: {} }
			);

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		async exportarLogsAlteracao() {
			this.carregando = true;

			var response = await this.$http().post(
				"/fornecedor/exportarLogsAlteracao",
				{ data: {} }
			);

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		abrirEditar(item) {
			try {
                this.$refs.formEditar.resetValidation()
            } catch (error) {
                console.log(error)
            }
			this.fornecedor = { ...item };

			this.dialogo = true;
		},
		enviarGuias(item) {
			this.fornecedor = { ...item };
			this.dialogoEnvioGuias = true;
		},
		validaNeogrupo() {
			const otc = parseFloat(this.fornecedor.perc_otc);
			const perf = parseFloat(this.fornecedor.perc_perfumaria);
			const rx = parseFloat(this.fornecedor.perc_rx);
			const algumPreenchido = !isNaN(otc) || !isNaN(perf) || !isNaN(rx);
			if (!algumPreenchido) return true;
			const soma = Math.round(((isNaN(otc) ? 0 : otc) + (isNaN(perf) ? 0 : perf) + (isNaN(rx) ? 0 : rx)) * 100) / 100;
			if (soma !== 100) {
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = 5000;
				this.alertaTexto = "A soma dos percentuais OTC + Perfumaria + RX deve ser exatamente 100%.";
				return false;
			}
			return true;
		},
		async editar() {
			if (!this.$refs.formFiltro.validate()) return;
			if (!this.validaNeogrupo()) return;
			this.carregando = true;

			var data = this.fornecedor;

			var response = await this.$http().post("/fornecedor/editar", {
				data: data,
			});

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();

				this.dialogo = false;
			} else {
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = -1;
				this.alertaTexto = response.data.msg;
			}
		},
		abrirImportar() {
			if (!this.$refs.formFiltro.validate()) return;

			this.arquivoCSV = null;
			this.erro = false;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			this.dialogoImportar = true;
		},
		async importar() {
			this.carregando = true;

			var data = { mes: this.mes + "-01" };

			var formData = new FormData();

			formData.append("files", this.arquivoCSV);
			formData.append("data", JSON.stringify(data));

			this.arquivoCSV = null;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			var response = await this.$http().post(
				"/fornecedor/importar",
				formData
			);

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();
				this.dialogoImportar = false;
			} else {
				this.filtrar();
				this.erros = response.data.erros;
				this.pagination.page = 1;
				this.erro = true;
			}
		},
		abrirImportarEspecial() {
			if (!this.$refs.formFiltroEspecial.validate()) return;

			this.arquivoCSVEspecial = null;
			this.erro = false;

			try {
				this.$refs.formEspecial.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			this.dialogoImportarEspecial = true;
		},
		async importarEspecial() {
			this.carregando = true;

			var data = { mes: this.mesEspecial + "-01" };

			var formData = new FormData();

			formData.append("files", this.arquivoCSVEspecial);
			formData.append("data", JSON.stringify(data));

			this.arquivoCSVEspecial = null;

			try {
				this.$refs.formEspecial.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			var response = await this.$http().post(
				"/fornecedorEspecial/importar",
				formData
			);

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrarEspeciais();
				this.dialogoImportarEspecial = false;
			} else {
				this.filtrarEspeciais();
				this.erros = response.data.erros;
				this.paginationEspeciais.page = 1;
				this.erro = true;
			}
		},
	},
};
</script>

<style>
.fornecedor-tabs .activeMyClass:hover:before {
	background: none;
}
.fornecedor-tabs .v-tab:before {
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
}
.fornecedor-tabs .v-tabs-slider {
	width: 70%;
	margin: 0 15%;
}
.fornecedor-tabs .v-tab {
	width: 200px;
	font-size: 1.2rem;
	font-weight: normal !important;
	letter-spacing: 0px;
	color: #999 !important;
	text-transform: none !important;
}
.fornecedor-tabs .activeMyClass {
	background: #fff;
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
	color: #000 !important;
}
</style>
